module.exports = __webpack_public_path__ + "static/img/icon_app_btn_sel.2b84605.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/hsbpc/views/welcome/components/img/icon_app_btn_sel.png
// module id = TUBZ
// module chunks = 1